import { render, staticRenderFns } from "./DebtorConfirmBtn.vue?vue&type=template&id=0e22c440&"
import script from "./DebtorConfirmBtn.vue?vue&type=script&lang=js&"
export * from "./DebtorConfirmBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports